import { render, staticRenderFns } from "./ReceiptsTable.vue?vue&type=template&id=6a0fff34"
import script from "./ReceiptsTable.vue?vue&type=script&lang=js"
export * from "./ReceiptsTable.vue?vue&type=script&lang=js"
import style0 from "./ReceiptsTable.vue?vue&type=style&index=0&id=6a0fff34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports